import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=018029fc&scoped=true&"
import script from "./Activity.vue?vue&type=script&lang=js&"
export * from "./Activity.vue?vue&type=script&lang=js&"
import style0 from "./Activity.vue?vue&type=style&index=0&id=018029fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018029fc",
  null
  
)

export default component.exports